<nav class="mobile-menu" *ngIf="lm.showMenu" [@menuInOut]>
  <div class="overlay3"
       (click)="onClose($event)"
       (touchmove)="onTouchMove($event)"
       (wheel)="onWheel($event)"></div>

  <div class="mobile-menu-wrap">

    <div class="mobile-menu-contents">

      <a class="close-btn" (click)="onClose($event)"></a>

      <div class="mobile-menu-list">

        <!-- a class="menu-box-btn" [routerLink]="['/board', BBSCategory.NOTICE]" (click)="onClose($event)" -->
        <a class="menu-box-btn" [routerLink]="['/admin-msg']" (click)="onClose($event)">
          <div class="txt-box">운영자의 말</div>
        </a>

        <a class="menu-box-btn" [routerLink]="['/board', BBSCategory.USAGE]" (click)="onClose($event)">
          <div class="txt-box">베풀기</div>
        </a>

        <a class="menu-box-btn" [routerLink]="['/options']">
          <div class="txt-box">설정</div>
        </a>

        <div class="menu-box-btn">
          <div class="txt-box">소리 자동 재생</div>
          <div class="option-box">

            <div class="option-list">
              <div class="option-item-box">
                <label>
                  <input type="radio"
                         name="auto-play"
                         [checked]="autoPlay"
                         (click)="setAutoPlay(true)">
                  <span class="txt">켜기</span>
                </label>
              </div>
              <div class="option-item-box">
                <label>
                  <input type="radio"
                         name="auto-play"
                         [checked]="!autoPlay"
                         (click)="setAutoPlay(false)">
                  <span class="txt">끄기</span>
                </label>
              </div>
            </div>


          </div>
        </div>

        <!-- div class="menu-box-btn">
          <div class="txt-box">성조 표시 방식</div>
          <div class="option-box">

            <div class="option-list">
              <div class="option-item-box">
                <label>
                  <input type="radio" name="option2" checked>
                  <span class="txt">기호</span>
                </label>
              </div>
              <div class="option-item-box">
                <label>
                  <input type="radio" name="option2">
                  <span class="txt">사선</span>
                </label>
              </div>

              <div class="option-item-box">
                <label>
                  <input type="radio" name="option2">
                  <span class="txt">그림</span>
                </label>
              </div>

              <div class="option-item-box">
                <label>
                  <input type="radio" name="option2">
                  <span class="txt">색상</span>
                </label>
              </div>
            </div>


          </div>
        </div -->

        <a class="menu-box-btn"
           *ngIf="showDonation"
           [routerLink]="['/donation']"
           (click)="onClose($event)">
          <div class="txt-box">응원 하기</div>
        </a>

        <a class="menu-box-btn" [routerLink]="['/legal-notice']" (click)="onClose($event)">
          <div class="txt-box">책임의 한계와 법적인 고지</div>
        </a>

        <!-- div class="menu-box-btn">
          <div class="txt-box">회원가입
            <div class="social-list">
              <a href="#none" class="social-btn facebook"></a>
              <a href="#none" class="social-btn google"></a>
              <a href="#none" class="social-btn kakao"></a>
            </div>
          </div>
        </div -->

      </div>

    </div>



  </div>
</nav>
